import React from 'react';
import { Navbar, PageNotFound } from '../../../components';

const Games = () => {
  return (
    <>
      <Navbar />
      <PageNotFound />
    </>
  );
};

export default Games;